export const timeEntryQueryBase = {
	groupByDay: true,
};

export const userTeamsInclude = 'teams.users:withRecentlyDeleted(true)';
